import React, { Fragment } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Row, Button, FormGroup, Label, Input, Alert, Modal, ModalHeader,
    ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import Navbarh from '../navbar/Navbar';
import '../estilos.css';
import * as IoIcons from 'react-icons/io';
import Pagination from "react-js-pagination";
import Moment from 'moment';
import classnames from 'classnames';
import usePlaneacion from '../../hooks/usePlaneacion';
import QrReader from "react-qr-reader";
import BarcodeReader from 'react-barcode-reader';
import PlaneacionB from './PlaneacionB';
import PProduccionGen from '../produccion/PProduccionGen';
import AlmacenProduccion from '../produccion/AlmacenProduccion';




function Planeacion() {
    //Declaración de variables
    const { verpplaneacion, pplaneacion, formType, activeTab, toggle1, } = usePlaneacion();

    return (
        <>
            <Navbarh />
            {(pplaneacion === true || verpplaneacion === true) && (
                <>
                    <Row>
                        <div className="headerp col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <IoIcons.IoIosPaper className="iconoc floatleft" onClick={() => { toggle1('1'); }} />
                            <h3 >{formType}</h3>
                        </div>
                    </Row>
                    <div className="conteiner2">
                        <Fragment>
                            <div>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            className={pplaneacion === true || verpplaneacion === true ? "" : "displaynone"}
                                            onClick={() => { toggle1('1'); }}
                                        >
                                            Planeación base
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className={pplaneacion === true ? "" : "displaynone"}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { toggle1('2'); }}
                                        >
                                            Almacén
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className={pplaneacion === true ? "" : "displaynone"}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '3' })}
                                            onClick={() => { toggle1('3'); }}
                                        >
                                            Plan de producción
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab}>

                                    <TabPane tabId="1">
                                        <PlaneacionB />
                                    </TabPane>
                                    <TabPane tabId="2">
                                        {activeTab === "2" && (
                                            <AlmacenProduccion />
                                        )}
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <PProduccionGen />
                                    </TabPane>
                                </TabContent>
                            </div>



                        </Fragment>
                    </div>
                </>
            )}
        </>
    )
};



export default Planeacion